// Services
import SubscriptionService from '@/app/services/main/subscription/subscription-service';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

export const trackingSubscriptionMixins = {
	methods: {
		callTrackingSubscriptionAPI() {
			 return SubscriptionService.getSubscriptionTrack(this.$store.getters.getActivePet.id)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.$store.commit('setTrackingSubscription', res.data);
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true);
					}
				});
		}
	}
}